import { render, staticRenderFns } from "./CargoKanbanEdit.vue?vue&type=template&id=41f608b4"
import script from "./CargoKanbanEdit.vue?vue&type=script&lang=js"
export * from "./CargoKanbanEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports